import { memo, useEffect, useState, useRef } from "react"

import ProductService from "@/services/product"
import { Stack, Text, Image, AspectRatio, Center, Button, Container, Box, Table, IconButton, Input, Card, Heading, VStack } from "@chakra-ui/react"
import { useCart } from "contexts/cart"
import { formatCurrency } from "@/utilities/number"
import { LuPencil } from "react-icons/lu"

import { useApp } from "contexts/app"
import { useNavigate, useParams } from "react-router"
const PolicyPage = () => {
    const { setProcessing, setPageTitle, showToast } = useApp();
    useEffect(() => {
        setPageTitle("Chính sách")
    }, [setPageTitle])
    const navigate = useNavigate();

    return (
        <div style={{ paddingBottom: 75 }}>
            <Heading>
                1. ĐIỀU KIỆN TRỞ THÀNH ĐỐI TÁC Sỉ
            </Heading>

            <p>
                &#10003; Khách hàng có nhu cầu lấy hàng sỉ vui lòng cung cấp thông tin doanh nghiệp hoặc cá nhân kinh doanh.
                <br>
                </br>

                &#10003; Đạt số lượng tối thiểu theo quy định của Thuỷ Tiên Food để được áp dụng giá sỉ.
                <br>
                </br>

                &#10003;  Đơn hàng Sỉ tối thiểu là 1.000.000 đồng theo quy định của Thuỷ Tiên Food.

            </p>

            <Heading>
                2. CHÍNH SÁCH GIÁ VÀ CHIẾT KHẤU
            </Heading>
            <p>

                &#10003; Giá sỉ được áp dụng theo từng mức Sỉ số lượng.

                <br></br>
                &#10003; Hỗ trợ chiết khấu đặc biệt cho đối tác cam kết nhập hàng đều đặn.
                <br></br>
                &#10003;  Chương trình khuyến mãi được áp dụng linh hoạt theo từng thời điểm.

            </p>


            <Heading>
                3. HÌNH THỨC THANH TOÁN
            </Heading>

            <p>
                &#10003; Thanh toán linh hoạt: chuyển khoản, tiền mặt.
                <br></br>

                &#10003; Các đối tác lớn có thể đăng ký thanh toán theo chu kỳ.
            </p>


            <Heading>
                4. CHÍNH SÁCH GIAO HÀNG
            </Heading>



            <p>
                &#10003;  Hỗ trợ giao hàng tữ kho đến nơi theo thoã thuận.
                <br></br>
                &#10003; Phí vận chuyển được tính theo phí của các công ty vận chuyển.
            </p>


            <Heading>
                5. CHÍNH SÁCH HỖ TRỢ VÀ ĐỔI TRẢ HÀNG
            </Heading>

            <p>
                &#10003;  Hỗ trợ đổi hàng nếu sản phẩm lỗi do nhà sản xuất.
                <br></br>
                &#10003; Yêu cầu báo lỗi trong vòng 48h kể từ khi nhận hàng.
            </p>


            <Heading>
                6. LIÊN HỆ
            </Heading>

            <p>

                &#10003;  Hotline: 0911.575.968
                <br>
                </br>
                &#10003; Email: bossthuthuy@gmail.com
                <br>
                </br>
                &#10003;  Địa chỉ: p41-D2 Khu dân cư Capital, P. Lộc Sơn, Tp. Bảo Lộc, Tỉnh Lâm Đồng

            </p>
            <div>

            </div>
            <VStack style={{ marginTop: 16 }}>
                <Button onClick={e => navigate("/")}>Tiếp tục mua sắm</Button>
            </VStack>



        </div >
    )
}


export default memo(PolicyPage)